export default "__VITE_ASSET__PQ70sZ8z__"